// extracted by mini-css-extract-plugin
module.exports = {"MenuToggle":"_1mqO0RAMuFK81-mISg0x2s","open":"_1kMjGJLI9dfVIae0_bmzNx"};